import React from "react";

/**
 * Hairline row list: the marketing site's signature list rhythm.
 * Each row has a name (Atom Serif) on the left and a one-line description
 * on the right, separated by hairlines. Optional serifLead renders the name
 * area as a full-width serif lead sentence with no right column.
 */
export function HairlineList({ rows }) {
  return (
    <div className="e2-rows">
      {rows.map((r, i) => {
        if (r.serifLead) {
          return (
            <div key={i} className="e2-row" style={{ gridTemplateColumns: "1fr" }}>
              <div className="e2-serif-lead">{r.serifLead}</div>
            </div>
          );
        }
        return (
          <div key={i} className="e2-row" data-testid={r.testId}>
            <div className="e2-row-name">{r.name}</div>
            <div>
              <div className="e2-row-desc">{r.desc}</div>
              {r.cta}
            </div>
          </div>
        );
      })}
    </div>
  );
}
